import React, { useState } from 'react';

const ImageModal = ({ src }) => {

    const [openModal, setOpenModal] = useState(false)

    const handleOpenModal = (action) => {
        setOpenModal(action)
    }

    return (
        <>
            <div className='p-3 h-full cursor-pointer' onClick={() => handleOpenModal(true)}>
                <div className=" shadow-gray-600 shadow-md bg-white overflow-y-hidden">
                    <figure><img src={src} /></figure>
                </div>
            </div>
            <dialog id="my_modal_3" className={`bg-gray-600/40 backdrop-blur-sm fixed z-30 top-0 w-full h-screen justify-center ${openModal ? "flex" : "hidden"} `}>
                <div className="modal-box p-0 max-w-2xl max-h-max contenedor bg-fixed rounded-md">
                    <form method="dialog">
                        <button onClick={() => handleOpenModal(false)} className="z-20 border-none text-gray-700 btn btn-sm btn-circle bg-rose-200  hover:bg-rose-400 absolute right-2 top-2">✕</button>
                    </form>
                    <div className={`flex flex-col justify-end w-full transition-all h-full bg-cover bg-center`}>
                        <img className="absolute z-0 top-0 left-0 w-full h-full" src={src} alt={src} />
                    </div>
                </div>
            </dialog>
        </>
    );
};

export default ImageModal;